import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import type { DeletionRequestsData } from '@core/account-types';
import { HttpApiService } from '@core/http-legacy';

@Injectable({ providedIn: 'root' })
export class DeletionRequestsHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetchDeletionRequests(): Observable<DeletionRequestsData> {
    return this.httpApi.get('/deletion_requests', {}, { skipCompany: true });
  }
}
